import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class AwarenessOfIms extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'awarenessOfIms'}
            title={ t('support.procedure.P6.title') }
            exportTitle={ t('support.procedure.P6.exportTitle') }
            exportFileName={'awareness_of_ims.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (AwarenessOfIms);